export default "__VITE_ASSET__Dn4c47X0__"